import React from "react";
import NotificationActions from "./NotificationActions";

export default function DeviceActions({
  device,
  selectedDevices = [],
  toggleDevice,
}) {
  return (
    <NotificationActions
      device={device}
      selectedDevices={selectedDevices}
      toggleDevice={toggleDevice}
      size="default"
    />
  );
}
